import React from 'react'
import PropTypes from 'prop-types'

import { FormContext, useForm } from 'react-hook-form'

import AuditForm from 'views/ThirdPartyManagements/components/AuditForm'
import schema from 'views/ThirdPartyManagements/components/AuditForm/schema'

import ThirdPartyManagementStepperProvider from 'providers/ThirdPartyManagementStepperProvider'

const AuditFormContainer = ({
  companySupplier,
  audit = null,
  refresh,
  isPreAvaliation = false,
  isEdit = false,
  isShow = false,
  openTour = false,
  setOpenTour,
}) => {
  const formMethods = useForm({
    validationSchema: schema,
    defaultValues: {
      newResponsibleEmail: '',
      endDate: audit?.endDate || null,
      dateToSendEmails: audit?.dateToSendEmails || null,
      responsibleEmails:
        audit?.companySupplierAuditUsers?.map(
          (companySupplierAuditUser) => companySupplierAuditUser?.user?.email,
        ) || [],
      selectedQuizTemplates:
        audit?.companySupplierQuestionnaires?.map(
          (companySupplierQuestionnaire) =>
            companySupplierQuestionnaire?.questionnaire?.quizTemplateId,
        ) || [],
      simplifiedRegister: companySupplier?.simplifiedRegister || false,
    },
  })

  return (
    <ThirdPartyManagementStepperProvider
      isEdit={isEdit}
      isShow={isShow}
      isPreAvaliation={isPreAvaliation}
      companySupplier={companySupplier}
      refresh={refresh}
    >
      <FormContext {...formMethods}>
        <AuditForm
          isEdit={isEdit}
          isShow={isShow}
          audit={audit}
          openTour={openTour}
          setOpenTour={setOpenTour}
        />
      </FormContext>
    </ThirdPartyManagementStepperProvider>
  )
}

AuditFormContainer.propTypes = {
  companySupplier: PropTypes.object.isRequired,
  audit: PropTypes.object,
  refresh: PropTypes.func,
  isPreAvaliation: PropTypes.bool,
  isEdit: PropTypes.bool,
  isShow: PropTypes.bool,
  openTour: PropTypes.bool,
  setOpenTour: PropTypes.func,
}

export default AuditFormContainer
